import { render, staticRenderFns } from "./IELTSTrainingView.vue?vue&type=template&id=15196ee3&scoped=true"
import script from "./IELTSTrainingView.vue?vue&type=script&lang=js"
export * from "./IELTSTrainingView.vue?vue&type=script&lang=js"
import style0 from "./IELTSTrainingView.vue?vue&type=style&index=0&id=15196ee3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15196ee3",
  null
  
)

export default component.exports